import '@ionic/core';
import { setupConfig } from '@ionic/core';

/**
 * The code to be executed should be placed within a default function that is
 * exported by the global script. Ensure all of the code in the global script
 * is wrapped in the function() that is exported.
 */
export default async () => {
  // Suppress Chrome extension runtime errors
  const originalError = console.error;
  console.error = (...args) => {
    const message = args[0]?.toString() || '';
    if (message.includes('runtime.lastError') || 
        message.includes('Receiving end does not exist') ||
        message.includes('Could not establish connection')) {
      return; // Suppress these specific errors
    }
    originalError.apply(console, args);
  };

  // Also suppress console.warn for these messages
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const message = args[0]?.toString() || '';
    if (message.includes('runtime.lastError') || 
        message.includes('Receiving end does not exist') ||
        message.includes('Could not establish connection')) {
      return;
    }
    originalWarn.apply(console, args);
  };

  let mode = localStorage.getItem('mode')
  switch (mode) {
    case 'ios':
    case 'md':
      setupConfig({
        mode
      });
  }
};
